module.exports={
  "KCAW": {
    "key": "KCAW",
    "logo": "./assets/kcaw_logo.png",
    "link": "https://www.kcaw.org/",
    "alt_text_header": true
  },
  "KDLL": {
    "key": "KDLL",
    "logo": "",
    "link": "https://www.kdll.org/#stream/0"
  }
}